import { CompanyProfile } from '__generated__/GQL';

import getCountryByCode from './getCountryByCode';

const formatAddress = ({
  city,
  country,
  street,
  streetAddition,
  zip,
}: Partial<CompanyProfile>) =>
  [street, streetAddition, city, zip, getCountryByCode(country || '')]
    .filter((value) => value)
    .join(', ');

export default formatAddress;
